import { FormContent } from '../../RequestDraft/RequestForm/FormContent';
import { useParams } from 'react-router-dom';

export const RequestFormReadOnlyView = () => {
  const { id } = useParams();
  return <FormContent draftId={id as string} readOnly={true} />;
};
